import { EMPTY_PLACEHOLDER } from 'Data/constants.js'

export function isSkipped(value) {
  return value.answerValue === EMPTY_PLACEHOLDER && value.required === false
}

export function isAnswered(value) {
  return ![undefined, null, EMPTY_PLACEHOLDER].includes(value)
}

export function isUnAnswered(value) {
  return !isAnswered(value)
}
